import { useState } from "react"
import { useApi } from "../api";
import { AppHeader } from "../components/AppHeader"
import { ICargo } from "../interfaces";
import { Button, Form, FormControl, InputGroup, Modal } from "react-bootstrap";
import { InjectedCheckoutForm } from "../components/InjectedCheckoutForm";
import { useTranslation } from "react-i18next";
import { SuccessDialog } from "../components/SuccessDialog";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ErrorDialog } from "../components/ErrorDialog";
import { ErrorResponseDialog } from "../components/ErrorResponseDialog";
import { WarningDialog } from "../components/WarningDialog";
import { useNavigate } from "react-router-dom";

const stripePromise = loadStripe(window.location.hostname === "localhost" ? 'pk_test_70OCDjwDvtq6KIznGEYCB9l8' : 'pk_live_8x88Bq3MeZPoybzdXtNMDMpl');

export const NftPage = () => {
  const projectCode = 'SAI';
  const api = useApi(projectCode);
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const [amount, setAmount] = useState<number | null>(null)
  const [otp, setOtp] = useState<string | null>(null)
  const [showStripeModal, setShowStripeModal] = useState(false)
  const [showUsdtModal, setShowUsdtModal] = useState(false)
  const [modalTitle, setModalTitle] = useState('')

  return (
    <>
      <div className="content colorbk" style={{ backgroundImage: `url('https://ai.supercoin.network/img/bgr.jpg')`, backgroundSize: "100% 100%" }}>
        <AppHeader title="NFT 購買"></AppHeader>
        <div className="p-4 p-sm-5">
          <ol className="text-white list-decimal">
            <li>得 NFT(含收益分潤)</li>
            <li>平台交易手續費30%，依NFT認購百分比持續收入</li>
            <li>發行NFT事業機會</li>
          </ol>
        </div>
      </div>

      <div className="bg-white">

        <div className="tab-pane fade show active" id="perinfo" role="tabpanel" aria-labelledby="todayR-tab">
          <div className="loginmain px-3 px-sm-5" style={{ "borderRadius": 0 }}>
            <div className="loginmain px-3 px-sm-4">
              <div className="form-group text-left">
                <label className="loginT" htmlFor="staking">購買金額</label>
                <div className="btn-group-vertical w-100" role="group">
                  <input type="radio" className="d-none" name="buy" id="buy500" value="500" onClick={() => setAmount(500)} />
                  <label className="btn p-0 m-0 fs-14 color-8 btn-g-custom lab1" htmlFor="buy500">500</label>
                  <input type="radio" className="d-none" name="buy" id="buy0" value="1500" onClick={() => setAmount(1500)} />
                  <label className="btn p-0 m-0 fs-14 color-8 btn-g-custom lab1" htmlFor="buy0">1,500</label>
                  <input type="radio" className="d-none" name="buy" id="buy1" value="3000" onClick={() => setAmount(3000)} />
                  <label className="btn p-0 m-0 fs-14 color-8 btn-g-custom lab2" htmlFor="buy1">3,000</label>
                  <input type="radio" className="d-none" name="buy" id="buy2" value="5000" onClick={() => setAmount(5000)} />
                  <label className="btn p-0 m-0 fs-14 color-8 btn-g-custom lab2" htmlFor="buy2">5,000</label>
                  <input type="radio" className="d-none" name="buy" id="buy3" value="10000" onClick={() => setAmount(10000)} />
                  <label className="btn p-0 m-0 fs-14 color-8 btn-g-custom lab3" htmlFor="buy3">10,000</label>
                </div>
              </div>
              <div className="mt-3">付款方式</div>
              <div className="btn-group-vertical w-100" role="group">
                <div className="btn btn-outline-danger btn-block" style={{ height: 50, lineHeight: 2 }} onClick={() => {
                  setModalTitle('卡支付')
                  setShowStripeModal(true)
                }}>
                  VISA<span className="txt-12 text-secondary ml-2">(卡支付)</span>
                </div>
                <div className="btn btn-outline-danger btn-block" style={{ height: 50, lineHeight: 2 }} onClick={() => {
                  setModalTitle('數字貨幣閃兑')
                  setShowUsdtModal(true)
                }}>
                  USDT<span className="txt-12 text-secondary ml-2">(數字貨幣閃兑)</span>
                </div>
              </div>
              <ul className="nav nav-pills my-5">
                <li className="nav-item w-100">
                  <div className="btn btn-success btn-block mt-4 w-100" onClick={() => {
                    navigate(`/app/nft-pre-sale`)
                  }}>我的 NFT</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Modal
          show={showStripeModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => { setShowStripeModal(false) }}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Elements stripe={stripePromise}>
              <InjectedCheckoutForm projectCode={projectCode} product='preSaleNft' amount={amount || 0} onSuccess={() => {
                setShowStripeModal(false)
              }} />
            </Elements>
          </Modal.Body>
        </Modal>
        <Modal
          show={showUsdtModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => { setShowUsdtModal(false) }}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Form.Group className="mb-3">
                <Form.Label>安全驗證</Form.Label>
                <InputGroup>
                  <FormControl
                    type="password"
                    onChange={(e) => {
                      setOtp(e.target.value)
                    }}
                    aria-label={t('pleaseInputOtp')}
                  />
                  <Button variant="outline-danger" disabled={isLoading} onClick={() => {
                    setIsLoading(true)
                    api.sendOtp((cargo: ICargo) => {
                      setIsLoading(false)
                      if (cargo.returnCode === '000000') {
                        SuccessDialog({ title: t('otpSentSuccess') })
                      } else {
                        switch (cargo.returnCode) {
                          case '100003':
                            ErrorDialog({ title: t(`errorCode.${cargo.returnCode}`) })
                            window.location.href = '/login.html'
                            break;
                          default:
                            ErrorDialog({ title: t('otpSentFailure') })
                        }
                      }
                    })
                  }}>{t('sendOtp')}</Button>
                </InputGroup>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={isLoading} onClick={() => {
              if (amount === null || amount < 1000) {
                WarningDialog({ title: t('invalidAmount') });
                return
              }
              if (otp === null) {
                WarningDialog({ title: t('invalidOtp') });
                return
              }
              if (amount !== null && otp !== null) {
                setIsLoading(true)
                api.purchasePreSaleNftByUsdt(amount, otp, (cargo: ICargo) => {
                  setIsLoading(false)
                  if (cargo.returnCode === '000000') {
                    setShowUsdtModal(false)
                    SuccessDialog({ title: "Success", content: t('transactionRequestHasAlreadySubmitted') })
                  } else {
                    ErrorResponseDialog(cargo, t)
                  }
                })
              }
            }}>{isLoading ? t('processing') : t('preSaleNft')}</Button>
          </Modal.Footer>
        </Modal>
        <div style={{ 'height': '100px' }}></div>
      </div>
    </>
  )
}